// import { AnalyticsBrowser } from '@segment/analytics-next'
// const segment = AnalyticsBrowser.load({ writeKey: 'zfRU8PTTu1ebxKOFLYBasPwLH472n4mW' })

import mixpanel from 'mixpanel-browser'
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import {EventBus} from "@/eventBus";
import axios from "axios";


function frontendEnv() {

    // todo: Once we have our Capacitor iOS build, we'll need to add logic to distinguish local builds (dev) vs
    // todo:  published builds (prod), and any staging or sandbox versions in between.

    return (
        // unpackaged is always development
        ( process.env.NODE_ENV === 'development' ) ? 'development' :

        // look to the url for specific environments
        location?.origin?.includes('mol-sandbox-app') ? 'sandbox' :
            location?.origin?.includes('mol-staging-app') ? 'staging' :
                location?.origin?.includes('www.myoscarlist.com') ? 'production' :

        // default to development
        'development'
    );
}

//console.log(`sendEventsToDev() = ${sendEventsToDev()}`);

const MIXPANEL_TOKEN_PROD = '4448d86056d3c54311902f0488046645';
const MIXPANEL_TOKEN_DEV = 'f7e293a7d2a479bff9cb415ae686ea05';

mixpanel.init((frontendEnv() === 'production') ? MIXPANEL_TOKEN_PROD : MIXPANEL_TOKEN_DEV, {
    autocapture: false,
    persistence: 'localStorage',    // set persistence to local storage
    opt_out_tracking_by_default: true,
    //debug: true,                    // enable debug log in console
});
mixpanel.register({
    'frontend build version': document?.documentElement?.dataset?.molFrontendBuildVersion
});

Bugsnag.start({
    apiKey: 'dfca92a291f0741f026fd76ed706a488',
    plugins: [new BugsnagPluginVue()],
    appType: 'web_client',
    releaseStage: frontendEnv(),
    //enabledReleaseStages: [ 'production', 'staging' ],
    logger: null,
    appVersion: `fr.${document?.documentElement?.dataset?.molFrontendBuildVersion}`,
    // onError: function (event) {
    // }
});

export default {


    resetTrackingPreferences() {

        // we don't just clear on reset--we opt out, because that's the default for us
        //mixpanel.clear_opt_in_out_tracking();
        mixpanel.opt_out_tracking();

        localStorage.removeItem('cookie_preferences_set');

        EventBus.emit('analytics-tracking-preference-updated');
        //console.log(`has_opted_in_tracking=${mixpanel.has_opted_in_tracking()}  |  has_opted_out_tracking=${mixpanel.has_opted_out_tracking()}`)
    },

    optOutOfTracking() {
        localStorage.setItem('cookie_preferences_set', '1');
        mixpanel.opt_out_tracking();
        EventBus.emit('analytics-tracking-preference-updated');
        //console.log(`has_opted_in_tracking=${mixpanel.has_opted_in_tracking()}  |  has_opted_out_tracking=${mixpanel.has_opted_out_tracking()}`)
        axios.post(
            '/api/user/cookie-preferences',
            {
                allow_third_party_cookies: false
            });
    },
    optInToTracking() {
        localStorage.setItem('cookie_preferences_set', '1');
        mixpanel.opt_in_tracking();
        EventBus.emit('analytics-tracking-preference-updated');
        //console.log(`has_opted_in_tracking=${mixpanel.has_opted_in_tracking()}  |  has_opted_out_tracking=${mixpanel.has_opted_out_tracking()}`)
        axios.post(
            '/api/user/cookie-preferences',
            {
                allow_third_party_cookies: true
            });
    },

    hasSetTrackingPreferences() {
        return ( localStorage.getItem('cookie_preferences_set') !== null );
    },

    hasOptedInToTracking() {
      return mixpanel.has_opted_in_tracking();
    },

    hasOptedOutOfTracking() {
        return mixpanel.has_opted_out_tracking();
    },

    setUser(_user) {
        if ( _user ) {
            mixpanel.identify(_user._id);
            Bugsnag.setUser(_user._id, null, _user.username)
        } else {
            mixpanel.reset();
            Bugsnag.setUser(null, null, null);
        }
    },

    sendPage(_pageName, _properties) {
        mixpanel.track_pageview({
            "page": _pageName,
            ..._properties
        });

        if ( _pageName === 'WelcomePage' && !this.hasOptedInToTracking()) {
            axios.post(
                '/api/user/page-view',
                {
                    "page": _pageName,
                    'distinct_id': mixpanel.get_distinct_id(),

                    //'device_id': mixpanel.get_property('$device_id'),
                    // 'current_page_title': window.document.title,
                    // 'current_domain': window.location.hostname,
                    // 'current_url_path': window.location.pathname,
                    // 'current_url_protocol': window.location.protocol,
                    // 'current_url_search': window.location.search,
                    ..._properties
                });
        }
    },

    sendEvent(_eventName, _properties) {
        //console.log('send analytics event', _eventName, _properties);
        mixpanel.track(_eventName, _properties);
    },

    sendAchievement(_achievementName, _properties) {
        this.sendEvent('achievement_awarded', {
            achievement: _achievementName,
            ..._properties
        });
    },

    notifyBugsnagOfError(_error, _metadata=null) {
        Bugsnag.notify(_error, ((event) => {

            // don't send development build errors
            if ( event.app.releaseStage === 'development' ) {
                console.log('nope')
                return false;
            }

            if ( _metadata ) {
                event.addMetadata('myOscarList', _metadata);
            }
        }));
    },

    notifyBugsnagOfWarning(_error, _metadata=null) {
        Bugsnag.notify(_error, ((event) => {

            // don't send development build warnings
            if ( event.app.releaseStage === 'development' ) {
                return false;
            }

            event.severity = 'warning';
            event.errors.forEach((error) => {
                error.errorClass = 'Warning';
            });

            if ( _metadata ) {
                event.addMetadata('myOscarList', _metadata);
            }
        }));
    },

    notifyBugsnagOfInfo(_error, _metadata=null) {
        Bugsnag.notify(_error, ((event) => {

            // don't send development build info
            if ( event.app.releaseStage === 'development' ) {
                return false;
            }

            event.severity = 'info';
            event.errors.forEach((error) => {
                error.errorClass = 'Info';
            });

            if ( _metadata ) {
                event.addMetadata('myOscarList', _metadata);
            }
        }));
    },

    sendBugsnagTestEvent(_metadata=null) {
        Bugsnag.notify('test event from client', ((event) => {

            // we DO send test events, even to development
            event.severity = 'info';
            event.errors.forEach((error) => {
                error.errorClass = 'TestError';
            });
            event.context = 'Client Test Event';

            if ( _metadata ) {
                event.addMetadata('myOscarList', _metadata);
            }
        }));
    },


    leaveBugsnagBreadcrumb(_name, _metadata, _type) {
        Bugsnag.leaveBreadcrumb(_name, _metadata, _type);
    },

}